module.exports = __webpack_public_path__ + "img/zq_2.f4680d5a.png";